import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalData } from '../../model/modal-data.model';
import { ShowAdvertStatisticsData } from './show-advert-statistics.interface';
import {
  OlxAdvertFullStatistics,
  OlxAdvertItem,
} from '../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { PowerOlxV2Service } from '../../modules/crm/power-olx-v2/services/power-olx-v2.service';
import { RequestHelper } from '../../services/request-helper.service';
import { Subject } from 'rxjs';
import { ADVERT_STATISTICS_ICONS_MAP } from '../../modules/crm/power-olx-v2/interfaces/power-olx-tab-item.interface';

@Component({
  selector: 'app-show-advert-statistics',
  templateUrl: './show-advert-statistics.component.html',
  styleUrl: './show-advert-statistics.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowAdvertStatisticsComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private channelId!: string;
  protected advert!: OlxAdvertItem;
  protected statistics?: OlxAdvertFullStatistics;
  protected loaders = {
    statistics: true,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: ModalData<ShowAdvertStatisticsData>,
    private readonly powerOlxV2Service: PowerOlxV2Service,
    private readonly requestHelper: RequestHelper,
  ) {}

  ngOnInit(): void {
    this.initData();
    this.initAdvertStatistic();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initData(): void {
    this.channelId = this.data.data!.channel_id;
    this.advert = this.data.data!.advert;
  }

  private initAdvertStatistic(): void {
    this.requestHelper.handle<OlxAdvertFullStatistics>(
      this.powerOlxV2Service.getAdvertFullStatistics(this.channelId, this.advert.id),
      (statistic: OlxAdvertFullStatistics) => {
        this.statistics = statistic;
      },
      {
        key: 'power_olx_advert_full_statistics',
        destroy$: this.destroy$,
        loaderRef: this.loaders,
        loaderKey: 'statistics',
        defaultErrorMessage: 'notifications_texts.error.failed_to_retrieve_advert_statistics',
      },
    );
  }

  protected readonly ADVERT_STATISTICS_ICONS_MAP: Record<string, string> = ADVERT_STATISTICS_ICONS_MAP;
  protected readonly Object = Object;
}
